import { HighlightAssetList as HighlightAssetList$1 } from '@cbhq/cdx-components';
import { getEntryProps } from '../utils/getEntryProps.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_ASSET_LIST_MODEL_ID = 'cdxHighlightAssetList';
function HighlightAssetList({
  assets,
  title,
  anchor
}) {
  const formattedAssets = assets?.map(asset => {
    const _getEntryProps = getEntryProps(asset),
      _getEntryProps$name = _getEntryProps.name,
      name = _getEntryProps$name === void 0 ? '' : _getEntryProps$name,
      link = _getEntryProps.link,
      logo = _getEntryProps.logo;
    const _getEntryProps2 = getEntryProps(link),
      _getEntryProps2$url = _getEntryProps2.url,
      href = _getEntryProps2$url === void 0 ? '' : _getEntryProps2$url;
    const _getEntryProps3 = getEntryProps(logo),
      file = _getEntryProps3.file;
    return {
      name,
      link: href,
      logoSrc: file?.url || ''
    };
  });
  return /*#__PURE__*/jsx(HighlightAssetList$1, {
    assets: formattedAssets,
    title: title,
    anchor: anchor
  });
}
export { HIGHLIGHT_ASSET_LIST_MODEL_ID, HighlightAssetList };
//# sourceMappingURL=HighlightAssetList.js.map
